var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllLendosSignaturesComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 17.2852V32.5C32.5 33.4946 32.1049 34.4484 31.4017 35.1517C30.6984 35.8549 29.7446 36.25 28.75 36.25H11.25C10.2554 36.25 9.30161 35.8549 8.59835 35.1517C7.89509 34.4484 7.5 33.4946 7.5 32.5V7.5C7.5 6.50544 7.89509 5.55161 8.59835 4.84835C9.30161 4.14509 10.2554 3.75 11.25 3.75H18.9648C19.6277 3.7501 20.2633 4.01341 20.732 4.48203L31.768 15.518C32.2366 15.9867 32.4999 16.6223 32.5 17.2852Z",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.56 19C15.9429 19 13 21.9429 13 25.56C13 29.1771 15.9429 32.12 19.56 32.12C23.1771 32.12 26.12 29.1771 26.12 25.56C26.12 21.9429 23.1771 19 19.56 19ZM22.974 23.3615L18.7353 28.4076C18.6888 28.463 18.6309 28.5077 18.5656 28.5388C18.5003 28.5699 18.4291 28.5865 18.3568 28.5877H18.3483C18.2776 28.5877 18.2076 28.5728 18.143 28.544C18.0784 28.5152 18.0206 28.4731 17.9733 28.4205L16.1567 26.4021C16.1105 26.3531 16.0747 26.2955 16.0511 26.2325C16.0276 26.1695 16.0169 26.1024 16.0197 26.0352C16.0224 25.968 16.0386 25.9021 16.0672 25.8412C16.0958 25.7803 16.1363 25.7258 16.1863 25.6808C16.2363 25.6358 16.2948 25.6013 16.3583 25.5792C16.4218 25.5572 16.4891 25.548 16.5562 25.5523C16.6233 25.5567 16.6889 25.5743 16.7491 25.6044C16.8093 25.6344 16.8629 25.6761 16.9067 25.7272L18.335 27.3142L22.2013 22.7124C22.2881 22.6121 22.4108 22.55 22.5429 22.5395C22.6751 22.529 22.8061 22.5708 22.9076 22.6561C23.0091 22.7414 23.073 22.8632 23.0854 22.9952C23.0978 23.1271 23.0578 23.2587 22.974 23.3615Z",
    fill: "#287A26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4.375V13.75C20 14.413 20.2634 15.0489 20.7322 15.5178C21.2011 15.9866 21.837 16.25 22.5 16.25H31.875",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllLendosSignaturesComplete);
export default __webpack_public_path__ + "static/media/all-lendos-signatures-complete.5168cc83e902f68f4645670a82c61abd.svg";
export { ForwardRef as ReactComponent };